export default `
  query customAttributeMetadataV2($attributes: [AttributeInput!]) {
  customAttributeMetadataV2(attributes: $attributes){
    items {
        code
        label
        entity_type
        frontend_input
        is_required
        default_value
        is_unique
        options {
            label
            value
        }
    }
    errors {
        type
        message
    }
  }
}
`;
